import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { getProductosCatalogo } from '../../services/productosApi';
import { obtenerCategorias } from '../../services/categoriasServicio';
import { registrarPedidoMesa, obtenerPrecuentaMesa, obtenerDetalleMesa } from '../../services/pedidosServicio';
import { toast, ToastContainer } from 'react-toastify';
import config from '../../config/apiConfig';
import { getDatosNegocio } from '../../services/NegocioServicio';
import { useLocation } from 'react-router-dom';
import imgDefault from '../../imgs/defecto.png';
import { resolveImagenUrl } from '../../config/appConfig';
import MenuCategorias from '../menu/MenuCategorias';
import { useAlert } from '../../Components/context/AlertContext'; // Ajusta la ruta
import SelectorVariantesModal from '../../Components/Generales/SelectorVariantes';
import PaymentModalTPV from '../../Components/Tienda/Checkout/PaymentModalTPV';
import { confirmarPagoMesa } from '../../services/pedidosServicio';
import { fetchConfiguracionParametros, obtenerMetodosPagoPersonalizados } from '../../services/ConfiguracionServicio';

// 🚩 IMPORTAMOS EL COMPONENTE ITEM PARA TENER EL MISMO DISEÑO DEL TPV
import { Item } from '../Tienda/Catalogo/Item';

function formatCLP(price) {
    return Number(price || 0).toLocaleString('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: 0 });
}

// Dependiendo de cómo lo exportes, puede llamarse PedidosMesaForm o CatalogoMesas
const CatalogoMesas = ({ mesa, onVolver, garzon, onCambiarGarzon }) => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const esSoloLectura = queryParams.get('modo') === 'menu' || queryParams.get('modo') === 'catalogo';

    const [productos, setProductos] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [categoriaActual, setCategoriaActual] = useState(null);
    const [carroLocal, setCarroLocal] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isCartVisible, setIsCartVisible] = useState(false);

    const listaPCScrollRef = useRef(null);
    const listaMovilScrollRef = useRef(null);
    const [itemParaPersonalizar, setItemParaPersonalizar] = useState(null);
    const [editandoItemIdx, setEditandoItemIdx] = useState(null); // 🚩 Para editar items del carro
    const [configNegocio, setConfigNegocio] = useState(null);
    const [alertaExito, setAlertaExito] = useState({ visible: false, titulo: '', mensaje: '' });
    const [observacionMesa, setObservacionMesa] = useState('');
    const [comensales, setComensales] = useState(1); // Por defecto 1
    const [modalPagoMesaAbierto, setModalPagoMesaAbierto] = useState(false);
    const [datosPagoMesa, setDatosPagoMesa] = useState({ total: 0, comensales: 1, pedidoId: null });
    const [modalPropinaMesaAbierto, setModalPropinaMesaAbierto] = useState(false);
    const [propinaMesaSeleccionada, setPropinaMesaSeleccionada] = useState(0);
    const [subtotalPagoMesa, setSubtotalPagoMesa] = useState(0);
    const [itemsPagoMesa, setItemsPagoMesa] = useState([]); // 🚩 Para guardar items antes de pagar
    const [pagoEnMesaHabilitado, setPagoEnMesaHabilitado] = useState(false);
    const [precuentaGenerada, setPrecuentaGenerada] = useState(false);
    const [metodosPagoPersonalizados, setMetodosPagoPersonalizados] = useState([]);
    // 🚩 Cargar flag PAGO_EN_MESA al montar
    useEffect(() => {
        const cargarFlag = async () => {
            try {
                const res = await fetchConfiguracionParametros();
                if (res && res.ajustes) {
                    setPagoEnMesaHabilitado(res.ajustes.PAGO_EN_MESA === true);
                }
            } catch (e) {
                console.error("Error cargando PAGO_EN_MESA:", e);
            }
        };
        cargarFlag();

        obtenerMetodosPagoPersonalizados().then(data => {
            setMetodosPagoPersonalizados(Array.isArray(data) ? data : []);
        }).catch(e => console.error("Error cargando métodos de pago personalizados:", e));
    }, []);

    // 👇 PEGA ESTE USEEFFECT 👇

    useEffect(() => {
        setTimeout(() => {
            if (listaPCScrollRef.current) {
                listaPCScrollRef.current.scrollTo({ top: listaPCScrollRef.current.scrollHeight, behavior: 'smooth' });
            }
            if (listaMovilScrollRef.current) {
                listaMovilScrollRef.current.scrollTo({ top: listaMovilScrollRef.current.scrollHeight, behavior: 'smooth' });
            }
        }, 100); // Un pequeño retraso de 100ms para asegurar que React ya dibujó el item nuevo
    }, [carroLocal, isCartVisible]);

    const dispararAlerta = useAlert(); // 🚩 Inicializas el hook

    // 🚩 FUNCIÓN A: Habla con el servidor (Python)
    const actualizarComensalesRapido = async (nuevoNumero) => {
        try {
            if (!mesa || !mesa.id) return;
            const mesaId = mesa.id;
            const token = localStorage.getItem("token");

            // Este fetch le avisa al Python que el número cambió sin esperar a "Marchar"
            await fetch(`${config.api_url}/api/v1/pedidos/mesa/${mesaId}/comensales`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'token': token },
                body: JSON.stringify({ comensales: nuevoNumero })
            });
        } catch (e) {
            console.error("Error sincronizando comensales");
        }
    };

    // 🚩 FUNCIÓN B: La que llaman los botones (Controla todo)
    const cambiarComensales = (nuevoValor) => {
        if (nuevoValor < 1) return; // Evita que pongan 0 o números locos

        setComensales(nuevoValor); // Cambia el número en la pantalla

        if (mesa && mesa.id) {
            localStorage.setItem(`comensales_mesa_${mesa.id}`, nuevoValor); // Guarda borrador
            actualizarComensalesRapido(nuevoValor); // Le avisa al servidor
        }
    };

    var productosFiltrados = categoriaActual ? productos.filter(function (p) { return String(p.categoria_id) === String(categoriaActual); }) : productos;

    useEffect(function () {
        var init = async function () {
            setLoading(true);
            try {
                var results = await Promise.all([obtenerCategorias(), getProductosCatalogo(), fetchConfiguracionParametros()]);
                setCategorias(results[0] || []);
                setProductos(Array.isArray(results[1]) ? results[1] : (results[1].productos || []));
                setConfigNegocio(results[2] && results[2].ajustes ? results[2].ajustes : null);
                if (mesa && mesa.id) {
                    const res = await obtenerDetalleMesa(mesa.id);

                    if (res && res.items && res.items.length > 0) {
                        // MESA OCUPADA: Traemos lo que diga el servidor
                        setComensales(res.comensales || 1);
                        setCarroLocal(res.items.map(i => ({ ...i, esAntiguo: true })));
                        // Si el estado del pedido es 7 (precuenta/por pagar), activamos flag
                        if (res.estado_id === 7 || res.pedido_estado === 7) {
                            setPrecuentaGenerada(true);
                        } else {
                            setPrecuentaGenerada(false);
                        }
                    } else {
                        // 🚩 MESA VACÍA: Limpiamos todo rastro de los clientes anteriores
                        setCarroLocal([]);
                        setComensales(1);
                        setPrecuentaGenerada(false);
                        localStorage.removeItem(`comensales_mesa_${mesa.id}`);
                    }
                }
                /*if (mesa && mesa.id) {
                    console.log("Cargando detalle de mesa:", mesa.id);
                    const res = await obtenerDetalleMesa(mesa.id);
                    //recupero la cantidad de comensales
                    // 🚩 LÓGICA DE RECUPERACIÓN VIOH
                    if (res && res.comensales && res.comensales > 0) {
                        // Prioridad 1: Lo que dice la base de datos
                        setComensales(res.comensales);
                    } else {
                        // Prioridad 2: Lo que el garzón marcó antes de salir (LocalStorage)
                        const local = localStorage.getItem(`comensales_mesa_${mesa.id}`);
                        if (local) setComensales(parseInt(local));
                    }

                    console.log("Respuesta del servidor:", res);

                    if (res && res.items && res.items.length > 0) {
                        const itemsFormateados = res.items.map(i => ({
                            ...i,
                            esAntiguo: true // Esto es clave para que salgan con el check verde
                        }));
                        setCarroLocal(itemsFormateados);
                    } else {
                        setCarroLocal([]); // Si no hay nada, queda vacío
                    }
                } */
            } catch (e) {
                console.error("Error cargando mesa:", e);
            } finally {
                setLoading(false);
            }
        };
        init();
    }, [mesa]);

    // 🚩 FUNCIÓN PARA AGREGAR PRODUCTOS (DETECTA SI TIENE VARIANTES)
    const agregarAlCarro = (p) => {
        if (esSoloLectura) return;

        // 1. EXTRAER GRUPOS (Compatible con varios nombres de campo)
        const grupos = p.variantes || p.grupos || [];

        // 2. VALIDACIÓN PRO: ¿Tiene opciones reales dentro de los grupos?
        // Esto evita que arrays con basura o grupos vacíos levanten el modal.
        const tieneOpcionesReales = grupos.some(g =>
            g && g.opciones && Array.isArray(g.opciones) && g.opciones.length > 0
        );

        // 3. SOLO levantamos el modal si hay algo que elegir O si es venta por peso
        if ((tieneOpcionesReales) || p.venta_por_peso === 1) {
            setItemParaPersonalizar(p);
            return;
        }

        // 4. Si pasó las pruebas de arriba, va directo al carro
        setCarroLocal(function (prev) {
            // Buscamos si ya existe en el carro (pero que no sea de un pedido anterior 'esAntiguo')
            var ex = prev.find(function (i) {
                return i.id === p.id && !i.esAntiguo && !i.variantes_detalles;
            });

            if (ex) {
                return prev.map(function (i) {
                    return i.id === p.id && !i.esAntiguo && !i.variantes_detalles
                        ? Object.assign({}, i, { cantidad: i.cantidad + 1 })
                        : i;
                });
            } else {
                return prev.concat([Object.assign({}, p, { cantidad: 1, esAntiguo: false })]);
            }
        });

        toast.success("Agregado", { autoClose: 500, hideProgressBar: true });
    };


    // =========================================================================
    // 🚩 LÓGICA DEL MODAL DE VARIANTES (IGUAL AL TPV)
    // =========================================================================


    const encolarImpresionLocal = async (tipo, contenido) => {
        try {
            const baseUrl = config.api_url;
            const token = localStorage.getItem("token");

            const res = await fetch(`${baseUrl}/api/v1/impresion/encolar`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'token': token
                },
                body: JSON.stringify({
                    tipo: tipo,
                    contenido: contenido
                })
            });

            if (res.ok) {
                console.log(`✅ ${tipo} enviada a cola de impresión`);
                return true;
            } else {
                console.error("❌ Error al encolar impresión");
                return false;
            }
        } catch (error) {
            console.error("💥 Error de red al encolar:", error);
            return false;
        }
    };



    // =========================================================================

    var handleMarchar = async function () {
        var mesaId = (mesa && mesa.id) ? mesa.id : null;
        if (!mesaId) { alert("ERROR: La mesa no está cargada."); return; }

        var nuevos = carroLocal.filter(function (i) { return !i.esAntiguo; });
        if (nuevos.length === 0) { toast.info("No hay productos nuevos."); return; }

        setIsSubmitting(true);
        try {
            // 🚩 CORREGIDO: Incluye precio de variantes (opciones_escogidas)
            var total = nuevos.reduce(function (a, b) {
                var precioBase = Number(b.precio || 0) * Number(b.cantidad || 0);
                var precioVariantes = 0;
                if (b.opciones_escogidas && Array.isArray(b.opciones_escogidas)) {
                    precioVariantes = b.opciones_escogidas.reduce(function (sum, opt) {
                        return sum + (Number(opt.precio || 0) * Number(b.cantidad || 0));
                    }, 0);
                }
                return a + precioBase + precioVariantes;
            }, 0);
            // El garzon viene por prop (se eligio al abrir ESA mesa). Si no,
            // se lee el respaldo guardado PARA ESTA MESA. Nunca uno global:
            // si no, se colaria el garzon de otra mesa.
            var garzonNombre = (garzon && garzon.nombre) ? garzon.nombre : null;
            if (!garzonNombre) {
                try {
                    var guardado = localStorage.getItem('garzon_mesa_' + mesa.id);
                    if (guardado) {
                        var g = JSON.parse(guardado);
                        garzonNombre = (g && g.nombre) ? g.nombre : null;
                    }
                } catch (e) {}
            }

            var res = await registrarPedidoMesa({
                mesa_id: mesaId, cartItems: nuevos,
                total: total,
                lugar_consumo: 'SERVIR',
                observacion: observacionMesa,
                comensales: comensales, // 🚩 ¡VITAL! Si no, el Python recibe null
                garzon_nombre: garzonNombre,
                terminal_nombre: localStorage.getItem('terminalNombre') || null
            });

            if (res && (res.status === 'success' || res.status === 'ok')) {
                dispararAlerta("¡Comanda Enviada!", "El pedido ya se está imprimiendo en cocina.");

                // 🚩 Preparamos los datos tal cual se van a la impresora
                console.log("comensales", comensales)
                const datosComanda = {
                    id: res.pedido_id || 'MESA-' + mesaId,
                    display_id: mesa.nombre, // 🚩 TITULO LIMPIO COMO PEDISTE
                    nombre_cliente: mesa.nombre,
                    lugar_consumo: 'SERVIR',
                    observacion: observacionMesa,
                    cartItems: nuevos.map(function (item) {
                        // 🚩 CORREGIDO: Incluye precio individual + precio de variantes
                        var precioItem = Number(item.precio || 0);
                        var precioVariantes = 0;
                        if (item.opciones_escogidas && Array.isArray(item.opciones_escogidas)) {
                            precioVariantes = item.opciones_escogidas.reduce(function (sum, opt) {
                                return sum + Number(opt.precio || 0);
                            }, 0);
                        }
                        return {
                            cantidad: item.cantidad,
                            nombre: item.nombre,
                            precio: precioItem + precioVariantes,
                            nombre_categoria: (item.nombre_categoria || item.categoria || "VARIOS").toUpperCase(),
                            variantes: item.variantes_detalles || "",
                            descripcion: item.descripcion,
                        };
                    }),
                    comensales: comensales
                };

                setObservacionMesa('');
                // 🚩 GUARDAMOS EN EL DISCO LOCAL (LocalStorage) para que no se borre al salir
                localStorage.setItem(`ultimo_envio_mesa_${mesaId}`, JSON.stringify(datosComanda));

                try {
                    await encolarImpresionLocal('COMANDA', datosComanda);
                    //imprimirComandaCocina(datosComanda);
                } catch (impErr) { }

                setCarroLocal(carroLocal.map(function (i) { return Object.assign({}, i, { esAntiguo: true }); }));
            } else {
                alert("Error del Servidor: " + (res ? (res.message || res.error || "Error") : "Sin respuesta"));
            }
        } catch (e) {
            alert("Error de red.");
        } finally { setIsSubmitting(false); }
    };

    const obtenerUrlImagen = (producto) => {
        const path = producto.url_imagen || producto.img || producto.imagen;
        if (!path || path === "null" || path === "" || path === undefined) return imgDefault;
        return resolveImagenUrl(path);
    };

    const ejecutarPrecuenta_ = async () => {
        if (!mesa) return;
        try {
            const data = await obtenerPrecuentaMesa(mesa.id);
            if (!data || !data.items) { toast.warn("Mesa sin productos."); return; }

            const subtotal = data.items.reduce((acc, i) => acc + (Number(i.precio || 0) * Number(i.cantidad || 0)), 0);
            let propina = 0;
            const propinaMesas = configNegocio && configNegocio.PROPINA_MESAS === true;
            const porcPropina = Number(configNegocio && configNegocio.PORCENTAJE_PROPINA || 0);
            if (propinaMesas && porcPropina > 0) {
                propina = Math.round(subtotal * (porcPropina / 100));
            }
            const total = subtotal + propina;
            const token = localStorage.getItem("token");

            // 🚩 CAMBIO: En lugar de fetch a localhost, mandamos a la COLA en la nube
            const baseUrl = config.api_url.replace(/\/$/, "");
            console.log("comensales que ban al backend", comensales)
            await fetch(`${baseUrl}/api/v1/impresion/encolar`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'token': token },
                body: JSON.stringify({
                    tipo: 'PRECUENTA',
                    contenido: {
                        id: data.id || mesa.pedido_actual_id,
                        display_id: mesa.nombre,
                        nombre_cliente: mesa.nombre,
                        subtotal, propina, total,
                        cartItems: data.items,
                        ancho_papel: 80,
                        //comensales: comensales // 🚩 ESTO FALTABA PARA QUE LLEGUE A LA IMPRESORA
                    }
                })
            });

            dispararAlerta("¡Precuenta Generada!", "Se ha enviado a imprimir el detalle de la mesa.");

            // Actualizar el estado del pedido a 7 (igual que antes)
            const pedidoId = data.id || mesa.pedido_actual_id;
            if (pedidoId) {
                await fetch(`${baseUrl}/api/v1/pedidos/${pedidoId}/cambiar_estado`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'token': token },
                    body: JSON.stringify({ nuevoEstadoId: 7, nuevo_total: total, propina: propina })
                });
            }
        } catch (error) {
            console.error(error);
            toast.error("Error al procesar precuenta");
        }
    };

    const ejecutarPrecuenta = async () => {
        if (!mesa) return;
        
        // 🚩 Validar que no haya productos nuevos sin marchar antes de generar precuenta
        const nuevos = carroLocal.filter(i => !i.esAntiguo);
        if (nuevos.length > 0) {
            toast.warning("Debes marchar los productos nuevos antes de generar la precuenta");
            return;
        }
        
        try {
            const data = await obtenerPrecuentaMesa(mesa.id);
            if (!data || !data.items) {
                toast.warn("Mesa sin productos.");
                return;
            }

            // 1. Calculamos totales
            const subtotal = data.items.reduce((acc, i) => acc + (Number(i.precio || 0) * Number(i.cantidad || 0)), 0);
            let propina = 0;
            const propinaMesas = configNegocio && configNegocio.PROPINA_MESAS === true;
            const porcPropina = Number((configNegocio && configNegocio.PORCENTAJE_PROPINA) || 10);
            if (propinaMesas && porcPropina > 0) {
                propina = Math.round(subtotal * (porcPropina / 100));
            }
            const total = subtotal + propina;
            const token = localStorage.getItem("token");
            const baseUrl = config.api_url.replace(/\/$/, "");

            // 2. Identificamos el Pedido ID (Crítico) - El backend retorna 'id', no 'pedido_id'
            const pedidoId = data.id || mesa.pedido_actual_id || (data.items[0] && data.items[0].pedido_id);

            console.log("DEBUG: Intentando precuenta para Pedido ID:", pedidoId);

            if (!pedidoId) {
                toast.error("No se encontró el ID del pedido para cambiar el estado.");
                // No retornamos aquí para que al menos intente imprimir
            }

            // 3. Encolar en la nube: el servicio de impresion de la caja la retira de la cola.
            //    (Antes iba directo a 127.0.0.1:3001, que desde un celular es el propio celular.)
            const encolada = await encolarImpresionLocal('PRECUENTA', {
                id: pedidoId,
                display_id: mesa.nombre,
                nombre_cliente: mesa.nombre,
                subtotal, propina, total,
                cartItems: data.items,
                ancho_papel: 80,
                mostrar_propina: true,
                porcentaje_propina: porcPropina
            });
            if (!encolada) {
                toast.error("No se pudo enviar la precuenta a imprimir. Intenta de nuevo.");
                return;
            }

            // 4. CAMBIAR ESTADO (Aquí está el ajuste)
            if (pedidoId) {
                const resEstado = await fetch(`${baseUrl}/api/v1/pedidos/${pedidoId}/cambiar_estado`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'token': token },
                    body: JSON.stringify({
                        nuevoEstadoId: 7, // 7 suele ser 'Precuenta' o 'Por Pagar'
                        nuevo_total: total,
                        propina: propina
                    })
                });

                if (resEstado.ok) {
                    console.log("✅ Estado cambiado a 7 exitosamente");
                    setPrecuentaGenerada(true);
                    dispararAlerta("¡Precuenta Generada!", "Se ha enviado a imprimir y la mesa cambió a 'Por Pagar'.");
                    if (!pagoEnMesaHabilitado) toast.info("Precuenta lista. El pago se registra desde caja.");
                    // 🚩 Si PAGO_EN_MESA está activo, NO salimos de la página para que aparezca el botón COBRAR
                    if (!pagoEnMesaHabilitado && onVolver) setTimeout(() => onVolver(), 1500);
                } else {
                    const errorData = await resEstado.json();
                    console.error("❌ Error al cambiar estado:", errorData);
                    toast.error("Impreso, pero no se pudo cambiar el estado en el sistema.");
                }
            }

        } catch (error) {
            console.error("💥 Error en precuenta:", error);
            toast.error("Error al procesar precuenta");
        }
    };

    const abrirPagoMesa = async () => {
        if (!mesa || !mesa.id) return;
        try {
            const data = await obtenerPrecuentaMesa(mesa.id);
            if (!data || !data.items) {
                toast.warn("La mesa no tiene productos para cobrar.");
                return;
            }
            const subtotal = data.items.reduce((acc, i) => acc + (Number(i.precio || 0) * Number(i.cantidad || 0)), 0);
            const propinaMesas = configNegocio && configNegocio.PROPINA_MESAS === true;
            const porcPropina = Number((configNegocio && configNegocio.PORCENTAJE_PROPINA) || 10);

            // 🚩 La precuenta puede venir con la propina ya sumada al total (el
            // estado 7 guarda subtotal + propina). Para no cobrarla dos veces,
            // separamos la base de la propina guardada antes de abrir la caja.
            const propinaGuardada = Number(data.propina || 0);
            const totalGuardado = Number(data.total || subtotal || 0);
            const baseTotal = Math.max(0, Number(
                data.total_sin_propina !== undefined && data.total_sin_propina !== null
                    ? data.total_sin_propina
                    : totalGuardado - propinaGuardada
            ) || 0);

            setSubtotalPagoMesa(subtotal);
            setItemsPagoMesa(data.items || []); // 🚩 Guardamos items para imprimir recibo después del pago
            setDatosPagoMesa({
                total: baseTotal,
                comensales: comensales,
                pedidoId: data.id
            });

            // 🚩 Si PROPINA_MESAS activo, mostrar modal de propina antes del pago
            if (propinaMesas && porcPropina > 0) {
                setPropinaMesaSeleccionada(Math.round(subtotal * (porcPropina / 100)));
                setModalPropinaMesaAbierto(true);
            } else {
                // Sin propina: limpiar cualquier monto que haya quedado de otra mesa.
                setPropinaMesaSeleccionada(0);
                setModalPagoMesaAbierto(true);
            }
        } catch (e) {
            toast.error("Error al obtener datos de la mesa");
        }
    };

    const handlePagoMesaSuccess = async (datosVenta) => {
        try {
            const { propina: propinaEnviada, ...restoVenta } = datosVenta;
            const propinaUsar = Number(propinaEnviada !== undefined ? propinaEnviada : propinaMesaSeleccionada) || 0;

            // 🚩 `restoVenta.total` ya viene con la propina incluida desde el
            // modal de pago (montoTotal = base + propina). No volver a sumarla.
            const totalFinal = Number(
                restoVenta.total !== undefined && restoVenta.total !== null
                    ? restoVenta.total
                    : Number(datosPagoMesa.total || subtotalPagoMesa) + propinaUsar
            );
            const descuentoValor = Number(restoVenta.monto_descuento || restoVenta.descuento_valor || 0);
            const descuentoPct = Number(restoVenta.descuento_porcentaje || 0);

            const res = await confirmarPagoMesa(mesa.id, {
                metodo_pago: restoVenta.metodo_pago,
                total: totalFinal,
                propina: propinaUsar,
                descuento_valor: descuentoValor,
                descuento_porcentaje: descuentoPct,
                dividido_entre: Number(restoVenta.dividido_entre || 1)
            });
            if (res && res.status === 'success') {
                // 🚩 Validar flag IMPRIMIR_RECIBO antes de imprimir
                const imprimirRecibo = configNegocio && configNegocio.IMPRIMIR_RECIBO !== false;
                if (imprimirRecibo) {
                    // 🚩 Imprimir RECIBO final con propina (usando items guardados ANTES del pago)
                    try {
                        const propinaMesas = configNegocio && configNegocio.PROPINA_MESAS === true;
                        const porcPropina = Number((configNegocio && configNegocio.PORCENTAJE_PROPINA) || 10);
                        if (itemsPagoMesa.length > 0) {
                            await encolarImpresionLocal('RECIBO', {
                                id: datosPagoMesa.pedidoId || mesa.pedido_actual_id,
                                display_id: mesa.nombre,
                                nombre_cliente: mesa.nombre,
                                subtotal: subtotalPagoMesa,
                                propina: propinaUsar,
                                total: totalFinal,
                                cartItems: itemsPagoMesa,
                                mostrar_propina: propinaMesas && propinaUsar > 0,
                                porcentaje_propina: porcPropina
                            });
                        }
                    } catch (printErr) {
                        console.error("Error imprimiendo recibo:", printErr);
                    }
                }

                setPrecuentaGenerada(false);
                dispararAlerta("¡Pago Exitoso!", res.message || "Mesa pagada correctamente.");
                setModalPagoMesaAbierto(false);
                if (onVolver) setTimeout(() => onVolver(), 1500);
            } else {
                toast.error((res && res.message) || "Error al confirmar pago");
            }
        } catch (e) {
            toast.error("Error de red al pagar");
        }
    };

    const handleReimprimirUltimo = async () => {
        const mesaId = mesa.id;
        // 🚩 Recuperamos lo que guardamos en handleMarchar (puros items de ese envío)
        const guardado = localStorage.getItem(`ultimo_envio_mesa_${mesaId}`);

        if (guardado) {
            try {
                const datosComanda = JSON.parse(guardado);

                // 🚩 Usamos la MISMA función que usa el botón verde de Marchar
                // Esto manda el JSON de nuevo a la cola de impresión
                const exito = await encolarImpresionLocal('COMANDA', datosComanda);

                if (exito) {
                    dispararAlerta("¡Re-impresión Exitosa!", "El ticket ha sido enviado nuevamente a cocina 🚀");
                } else {
                    toast.error("Error al mandar la re-impresión");
                }
            } catch (e) {
                toast.error("Error al procesar los datos guardados");
            }
        } else {
            toast.warn("No hay envíos previos para esta mesa en este dispositivo.");
        }
    };



    return (

        <div style={{
            position: 'fixed', // 🚩 LA MAGIA: Se despega de Bootstrap
            top: '70px',       // 🚩 La altura de tu Navbar (ajústalo si queda muy arriba o abajo)
            bottom: 0,         // 🚩 Pegado al suelo
            left: 0,           // 🚩 Pegado a la izquierda
            right: 0,          // 🚩 Pegado a la derecha
            display: 'flex',
            backgroundColor: 'white',
            zIndex: 1000,      // Pa que tape cualquier wea que ande volando
            overflow: 'hidden'
        }}>

            {/* ESTILOS DEL MODAL DE VARIANTES DEL TPV */}
            <style>{`
            .hide-scrollbar::-webkit-scrollbar { display: none; }
            .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
            .transition-all { transition: all 0.2s ease-in-out; }
            .card img { object-fit: contain; height: 120px; }
            
            /* Solo esto para el panel de la derecha */
            .contenedor-pedido-pc {
                width: 400px;
                border-left: 1px solid #ddd;
                display: flex;
                flex-direction: column;
                background-color: white;
                box-shadow: -5px 0 15px rgba(0,0,0,0.05);
            }
            `}</style>

            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                <div className="bg-white p-3 shadow-sm d-flex justify-content-between align-items-center" style={{ flexShrink: 0 }}>
                    <button className="btn btn-sm btn-light text-primary" onClick={onVolver}><i className="fas fa-chevron-left"></i></button>
                    <div className="d-flex flex-column align-items-center">
                        <h6 className="m-0 fw-bold text-uppercase">
                            {mesa ? (
                                <span className="badge mr-1" style={{ fontSize: '0.7rem', padding: '4px 8px', borderRadius: '20px', backgroundColor: '#f97316', color: '#fff' }}>
                                    <i className="fas fa-chair mr-1"></i> Mesa {mesa.nombre.replace('Mesa ', '')}
                                </span>
                            ) : 'NO HAY MESA'}
                        </h6>
                        {garzon && (
                            <small
                                className="text-muted"
                                style={{ fontSize: '0.7rem', cursor: onCambiarGarzon ? 'pointer' : 'default' }}
                                title={onCambiarGarzon ? "Cambiar garzón" : garzon.nombre}
                                onClick={onCambiarGarzon}
                            >
                                <i className="fas fa-user mr-1"></i>{garzon.nombre}
                                {onCambiarGarzon && <i className="fas fa-pen ml-1" style={{ fontSize: '0.55rem' }}></i>}
                            </small>
                        )}
                    </div>
                    <div className="d-flex" style={{ gap: '8px' }}>
                        {pagoEnMesaHabilitado && precuentaGenerada && (
                            <button className="btn btn-sm btn-success font-weight-bold shadow-sm" onClick={abrirPagoMesa}>
                                <i className="fas fa-cash-register mr-1"></i> COBRAR
                            </button>
                        )}
                        <button className="btn btn-outline-primary" onClick={ejecutarPrecuenta}><i className="fas fa-receipt"></i></button>
                    </div>
                </div>

                {/* 🚩 BARRA DE CATEGORÍAS MEJORADA (STICKY Y SCROLLABLE) */}
                {/*<div className="bg-white shadow-sm border-bottom sticky-top" style={{ z_index: 1020, top: 0 }}>
                    <div className="d-flex overflow-auto py-2 px-2 hide-scrollbar" style={{ whiteSpace: 'nowrap', gap: '8px' }}>
                        <button
                            className={"btn btn-sm rounded-pill px-4 fw-bold transition-all " + (categoriaActual === null ? 'btn-primary shadow' : 'btn-light border')}
                            onClick={() => setCategoriaActual(null)}
                        >
                            Todos
                        </button>

                        {categorias.map(c => (
                            <button
                                key={c.id}
                                className={"btn btn-sm rounded-pill px-4 fw-bold transition-all " + (categoriaActual === c.id ? 'btn-primary shadow' : 'btn-light border')}
                                onClick={() => setCategoriaActual(c.id)}
                            >
                                {c.nombre}
                            </button>
                        ))}
                    </div>
                </div>*/}
                {/* 🚩 BARRA DE CATEGORÍAS REUTILIZABLE */}
                <MenuCategorias
                    categorias={categorias}
                    categoriaActual={categoriaActual}
                    onSeleccionarCategoria={setCategoriaActual}
                />

                {/* 🚩 GRILLA DE PRODUCTOS RESPONSIVA */}
                <div style={{ flexGrow: 1, overflowY: 'auto', padding: '0 10px 10px 10px', backgroundColor: '#f8f9fa' }}>
                    {loading ? (
                        <div className="text-center p-5"><div className="spinner-border text-primary"></div></div>
                    ) : (
                        /* row-cols-2: 2 productos en celular 
                           row-cols-md-3: 3 productos en tablet
                           row-cols-lg-4: 4 productos en PC
                           g-2: espacio pequeño entre cartas (gap) */
                        <div className="row row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 g-2 g-md-3">
                            {productosFiltrados.map(p => (
                                <div key={p.id} className="col">
                                    <Item
                                        item={{ ...p, url_imagen: obtenerUrlImagen(p) }}
                                        agregarAlCarro={agregarAlCarro}
                                        // 🚩 ESTO ES CLAVE: mandamos el item al estado para que el Modal nuevo lo detecte
                                        onPersonalizarItem={(item) => setItemParaPersonalizar(item)}
                                        carro={carroLocal}
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            <div className="d-none d-md-flex flex-column bg-white shadow-lg" style={{ width: '400px', borderLeft: '1px solid #ddd' }}>
                <div className="text-white p-3 d-flex justify-content-between align-items-center"
                    style={{ flexShrink: 0, backgroundColor: '#f97316' }}>
                    <h6 className="m-0 fw-bold"><i className="fas fa-list-ul me-2"></i>PEDIDO DE MESA</h6>
                </div>

                <div ref={listaPCScrollRef} style={{ flexGrow: 1, overflowY: 'auto', padding: '15px', backgroundColor: '#f8f9fa' }}>
                    {carroLocal.length === 0 ? (
                        <div className="text-center text-muted mt-5"><i className="fas fa-utensils fa-2x mb-2"></i><p>Sin productos</p></div>
                    ) : (
                        carroLocal.map((i, idx) => (
                            <div key={idx} className={"card border-0 shadow-sm mb-2 rounded-3 " + (i.esAntiguo ? "border-start border-success border-4" : "")}>
                                <div className="card-body p-2 d-flex justify-content-between align-items-center">
                                    <div className="flex-grow-1">
                                        <div className="fw-bold small">{i.cantidad}x {i.nombre}</div>
                                        {i.variantes_detalles && <div className="small text-muted" style={{ fontSize: '0.75rem', lineHeight: '1.1' }}>{i.variantes_detalles}</div>}
                                        {i.esAntiguo && <div className="text-success small fw-bold mt-1"><i className="fas fa-check"></i> En cocina</div>}
                                        <div className="text-primary small fw-bold mt-1">{formatCLP(i.precio * i.cantidad)}</div>
                                    </div>
                                    {!i.esAntiguo && (
                                        <div className="d-flex gap-1">
                                            {/* 🚩 BOTÓN EDITAR VARIANTES */}
                                            {i.variantes_detalles && (
                                                <button className="btn btn-sm btn-outline-primary border-0" onClick={() => {
                                                    setEditandoItemIdx(idx);
                                                    // 🚩 Buscamos el producto original del catálogo para tener los grupos completos
                                                    const idReal = String(i.id).split('_')[0];
                                                    const productoCatalogo = productos.find(p => String(p.id) === idReal);
                                                    if (productoCatalogo && productoCatalogo.grupos) {
                                                        // Combinamos el producto del catálogo (con grupos) + las opciones escogidas del carro
                                                        setItemParaPersonalizar({
                                                            ...productoCatalogo,
                                                            opciones_escogidas: i.opciones_escogidas || [],
                                                            precio: i.precio // Preservamos el precio personalizado
                                                        });
                                                    } else {
                                                        setItemParaPersonalizar(i);
                                                    }
                                                }} title="Editar variantes">
                                                    <i className="fas fa-edit"></i>
                                                </button>
                                            )}
                                            <button className="btn btn-sm btn-outline-danger border-0" onClick={() => setCarroLocal(carroLocal.filter((_, index) => index !== idx))}>
                                                <i className="fas fa-trash-alt"></i>
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))
                    )}
                </div>

                <div style={{ padding: '15px', backgroundColor: 'white', borderTop: '1px solid #eee' }}>
                    {/* SELECTOR DE COMENSALES */}
                    <div className="d-flex align-items-center justify-content-between mb-3 p-2 bg-light border" style={{ borderRadius: '12px' }}>
                        <span className="small fw-bold text-muted text-uppercase ms-2">
                            <i className="fas fa-users me-2"></i> Comensales
                        </span>
                        <div className="d-flex align-items-center bg-white rounded-pill shadow-sm border" style={{ padding: '2px' }}>
                            <button className="btn btn-light rounded-circle" onClick={() => cambiarComensales(comensales - 1)}>
                                <i className="fas fa-minus"></i>
                            </button>
                            <span className="fw-bold text-center text-primary" style={{ fontSize: '1.2rem', width: '40px' }}>{comensales}</span>
                            <button className="btn btn-light rounded-circle" onClick={() => cambiarComensales(comensales + 1)}>
                                <i className="fas fa-plus"></i>
                            </button>
                        </div>
                    </div>

                    <label className="small fw-bold text-muted text-uppercase">Notas para la cocina:</label>
                    <textarea
                        className="form-control form-control-sm border-0 bg-light"
                        rows="2"
                        placeholder="Ej: Sin hielo, traer vasos..."
                        value={observacionMesa}
                        onChange={(e) => setObservacionMesa(e.target.value)}
                        style={{ fontSize: '0.85rem', borderRadius: '10px' }}
                    />

                    {/* 🚩 BOTÓN DE REIMPRESIÓN */}
                    {localStorage.getItem(`ultimo_envio_mesa_${mesa.id}`) && (
                        <button
                            className="btn w-100 mb-2 mt-3 fw-bold rounded-pill"
                            onClick={handleReimprimirUltimo}
                            style={{
                                height: '40px',
                                fontSize: '0.85rem',
                                color: '#f97316',
                                backgroundColor: 'white',
                                border: '1.5px solid #f97316',
                                boxShadow: '0 2px 4px rgba(249, 115, 22, 0.15)'
                            }}
                        >
                            <i className="fas fa-print me-2"></i> RE-IMPRIMIR ÚLTIMO ENVÍO
                        </button>
                    )}

                    <button className="btn btn-success btn-lg w-100 fw-bold rounded-pill shadow-sm" onClick={handleMarchar} disabled={isSubmitting}>
                        {isSubmitting ? 'ENVIANDO...' : 'MARCHAR A COCINA'}
                    </button>
                </div>
            </div>

            {!isCartVisible && carroLocal.length > 0 && (
                <div className="d-md-none position-fixed" style={{ bottom: '20px', right: '20px', zIndex: 9999 }}>
                    <button className="btn btn-success rounded-circle shadow-lg d-flex align-items-center justify-content-center" style={{ width: '65px', height: '65px' }} onClick={() => setIsCartVisible(true)}>
                        <i className="fas fa-shopping-basket fa-2x"></i>
                        <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger border border-light">{carroLocal.length}</span>
                    </button>
                </div>
            )}

            {isCartVisible && (
                <div className="d-md-none position-fixed top-0 start-0 w-100 h-100" style={{ zIndex: 9999, backgroundColor: 'rgba(0,0,0,0.6)' }} onClick={() => setIsCartVisible(false)}>

                    {/* MODAL PRINCIPAL COMPACTO Y FLEX */}
                    <div className="bg-white position-fixed bottom-0 start-0 w-100 d-flex flex-column"
                        style={{
                            height: '90vh', // 🚩 LO HICE MÁS ALTO PA QUE QUEPAN MÁS ITEMS
                            borderTopLeftRadius: '25px',
                            borderTopRightRadius: '25px',
                            boxShadow: '0 -10px 25px rgba(0,0,0,0.2)',
                            overflow: 'hidden'
                        }}
                        onClick={(e) => e.stopPropagation()}>

                        {/* 1. HEADER (Ocupa solo lo necesario) */}
                        <div className="d-flex justify-content-between align-items-center px-4 bg-white border-bottom" style={{ height: '60px', flexShrink: 0 }}>
                            <h6 className="fw-bold m-0">RESUMEN DEL PEDIDO</h6>
                            <button className="btn btn-light btn-sm rounded-circle shadow-sm" onClick={() => setIsCartVisible(false)} style={{ width: '35px', height: '35px' }}>
                                <i className="fas fa-times"></i>
                            </button>
                        </div>

                        {/* 2. LISTA DE ITEMS (Se estira automáticamente usando flex: 1) */}
                        <div className="p-3" style={{ flex: 1, overflowY: 'auto', backgroundColor: '#f8f9fa' }}>
                            {carroLocal.length === 0 ? (
                                <div className="text-center p-5 text-muted">Carro vacío</div>
                            ) : (
                                carroLocal.map((i, idx) => (
                                    <div key={idx} className="bg-white p-3 rounded-3 shadow-sm mb-2 d-flex justify-content-between align-items-center border-start border-4 border-primary">
                                        <div style={{ maxWidth: '80%' }}>
                                            <div className="fw-bold" style={{ fontSize: '0.9rem' }}>{i.cantidad}x {i.nombre}</div>
                                            {i.esAntiguo && <small className="text-success fw-bold"><i className="fas fa-check"></i> EN COCINA</small>}
                                            <div className="text-primary fw-bold">${(i.precio * i.cantidad).toLocaleString('es-CL')}</div>
                                        </div>
                                        {!i.esAntiguo && (
                                            <button className="btn btn-outline-danger btn-sm border-0" onClick={() => setCarroLocal(carroLocal.filter((_, index) => index !== idx))}>
                                                <i className="fas fa-trash-alt"></i>
                                            </button>
                                        )}
                                    </div>
                                ))
                            )}
                        </div>

                        {/* 3. FOOTER (Ocupa solo lo necesario, sin posiciones absolutas).
                            El padding inferior deja libre la barra de navegacion de Android, que si no tapa el boton MARCHAR A COCINA.
                            OJO: no usar p-3 aca, Bootstrap lo trae con !important y anula este paddingBottom. */}
                        <div className="bg-white border-top px-3 pt-3 shadow-lg" style={{ flexShrink: 0, paddingBottom: 'calc(64px + env(safe-area-inset-bottom, 0px))' }}>
                            {carroLocal.some(i => i.esAntiguo) && (
                                <button
                                    className="btn w-100 mb-2 fw-bold rounded-pill shadow-sm"
                                    onClick={handleReimprimirUltimo}
                                    style={{
                                        height: '40px',
                                        fontSize: '0.85rem',
                                        color: '#f97316',
                                        backgroundColor: 'white',
                                        border: '1.5px solid #f97316'
                                    }}
                                >
                                    <i className="fas fa-print me-2"></i> RE-IMPRIMIR ÚLTIMO
                                </button>
                            )}

                            {/* Comensales Móvil */}
                            <div className="d-flex align-items-center justify-content-between mb-2 p-1 bg-light border" style={{ borderRadius: '12px' }}>
                                <span className="small fw-bold text-muted text-uppercase ms-2"><i className="fas fa-users me-2"></i>Comensales</span>
                                <div className="d-flex align-items-center bg-white rounded-pill shadow-sm border" style={{ padding: '2px' }}>
                                    {/* Botón Menos */}
                                    <button className="btn btn-light rounded-circle" onClick={() => cambiarComensales(comensales - 1)}>
                                        <i className="fas fa-minus"></i>
                                    </button>

                                    <span className="fw-bold text-center text-primary" style={{ fontSize: '1.2rem', width: '40px' }}>{comensales}</span>

                                    {/* Botón Más */}
                                    <button className="btn btn-light rounded-circle" onClick={() => cambiarComensales(comensales + 1)}>
                                        <i className="fas fa-plus"></i>
                                    </button>
                                </div>
                            </div>

                            {/* Notas Móvil */}
                            <div className="mb-2">
                                <textarea
                                    className="form-control form-control-sm border-0 bg-light"
                                    rows="2"
                                    placeholder="Notas del pedido..."
                                    value={observacionMesa}
                                    onChange={(e) => setObservacionMesa(e.target.value)}
                                    style={{ fontSize: '0.85rem', borderRadius: '10px' }}
                                />
                            </div>

                            <button className="btn btn-success btn-lg w-100 fw-bold rounded-pill shadow-lg" onClick={handleMarchar} disabled={isSubmitting || carroLocal.filter(i => !i.esAntiguo).length === 0} style={{ height: '55px', fontSize: '1.1rem' }}>
                                {isSubmitting ? 'ENVIANDO...' : 'MARCHAR A COCINA'}
                            </button>
                        </div>
                    </div>
                </div>
            )}


            {/* 🚩 NUEVO MODAL UNIFICADO */}
            {itemParaPersonalizar && (
                <SelectorVariantesModal
                    item={itemParaPersonalizar}
                    editando={editandoItemIdx !== null}
                    onClose={() => {
                        setItemParaPersonalizar(null);
                        setEditandoItemIdx(null);
                    }}
                    onConfirm={(itemFinal) => {
                        if (editandoItemIdx !== null) {
                            // 🚩 MODO EDICIÓN: Reemplazamos el item en el carro
                            setCarroLocal(prev => prev.map((item, idx) =>
                                idx === editandoItemIdx ? { ...itemFinal, esAntiguo: false } : item
                            ));
                            setEditandoItemIdx(null);
                        } else {
                            // 🚩 MODO NUEVO: Agregamos al carro
                            setCarroLocal([...carroLocal, { ...itemFinal, esAntiguo: false }]);
                        }
                        setItemParaPersonalizar(null);
                        toast.success(editandoItemIdx !== null ? "Variante actualizada" : "Agregado al pedido", { autoClose: 500, hideProgressBar: true });
                    }}
                />
            )}
            {/* 🚩 MODAL DE PROPINA ANTES DEL PAGO */}
            {modalPropinaMesaAbierto && createPortal(
                <div className="position-fixed w-100 h-100 d-flex justify-content-center align-items-center p-3" style={{ zIndex: 10050, top: 0, left: 0, backgroundColor: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(5px)' }}>
                    <div className="bg-white rounded-4 shadow-lg d-flex flex-column" style={{ width: '400px', maxWidth: '92vw', maxHeight: '90vh', overflow: 'hidden', borderRadius: '20px' }}>
                        <div className="p-4 pb-2" style={{ overflowY: 'auto', flex: '1 1 auto' }}>
                        <h4 className="font-weight-bold mb-2 text-dark">Confirmar Propina</h4>
                        <p className="text-muted small mb-3">Mesa: {mesa && mesa.nombre ? mesa.nombre : ''} - Subtotal: ${Number(datosPagoMesa.total || 0).toLocaleString('es-CL')}</p>

                        {/* D2: detalle de ítems en pantalla, no solo en el ticket */}
                        {itemsPagoMesa.length > 0 && (
                            <div className="bg-light rounded-3 p-2 mb-3" style={{ maxHeight: '170px', overflowY: 'auto' }}>
                                <div className="small text-muted font-weight-bold text-uppercase mb-1">Ítems de la cuenta</div>
                                {itemsPagoMesa.map((item, idx) => (
                                    <div key={idx} className="d-flex justify-content-between small border-bottom py-1">
                                        <span className="text-truncate mr-2">{Number(item.cantidad || 0)}x {item.nombre || 'Producto'}</span>
                                        <span className="font-weight-bold">${(Number(item.precio || 0) * Number(item.cantidad || 0)).toLocaleString('es-CL')}</span>
                                    </div>
                                ))}
                            </div>
                        )}

                        <div className="form-group mb-4">
                            <label className="fw-bold">Monto de Propina ($):</label>
                            <input
                                type="number"
                                className="form-control form-control-lg text-primary fw-bold"
                                value={propinaMesaSeleccionada}
                                onChange={(e) => setPropinaMesaSeleccionada(Number(e.target.value))}
                                autoFocus
                            />
                            <div className="d-flex gap-2 mt-2">
                                <button className="btn btn-sm btn-outline-secondary" onClick={() => setPropinaMesaSeleccionada(0)}>Sin Propina</button>
                                <button className="btn btn-sm btn-outline-info" onClick={() => {
                                    const porcPropina = Number((configNegocio && configNegocio.PORCENTAJE_PROPINA) || 10);
                                    setPropinaMesaSeleccionada(Math.round(subtotalPagoMesa * (porcPropina / 100)));
                                }}>Sugerir {Number((configNegocio && configNegocio.PORCENTAJE_PROPINA) || 10)}%</button>
                            </div>
                        </div>

                        <div className="bg-light p-3 rounded-3 mb-4">
                            <div className="d-flex justify-content-between h5 m-0">
                                <span>Total a Cobrar:</span>
                                <span className="text-primary fw-bold">${(Number(datosPagoMesa.total || 0) + Number(propinaMesaSeleccionada || 0)).toLocaleString('es-CL')}</span>
                            </div>
                        </div>

                        </div>

                        <div className="px-4 pb-4 pt-2 d-flex flex-column gap-2" style={{ flex: '0 0 auto' }}>
                            <button className="btn btn-primary btn-lg fw-bold" onClick={() => {
                                setModalPropinaMesaAbierto(false);
                                setModalPagoMesaAbierto(true);
                            }}>
                                PASAR A CAJA <i className="fas fa-chevron-right ms-2"></i>
                            </button>
                            <button className="btn btn-link text-muted" onClick={() => setModalPropinaMesaAbierto(false)}>Cancelar</button>
                        </div>
                    </div>
                </div>,
                document.body
            )}
            {/* 🚩 MODAL DE PAGO EN MESA */}
            {modalPagoMesaAbierto && (
                <PaymentModalTPV
                    montoTotal={Number(datosPagoMesa.total || 0) + Number(propinaMesaSeleccionada || 0)}
                    pedido={{ id: datosPagoMesa.pedidoId, propina: Number(propinaMesaSeleccionada || 0), costo_envio: 0 }}
                    onClose={() => setModalPagoMesaAbierto(false)}
                    onPaymentSuccess={handlePagoMesaSuccess}
                    tipoVenta="MESA"
                    permiteDescuento={configNegocio && configNegocio.USA_DESCUENTOS === true}
                    permiteDividir={configNegocio && configNegocio.DIVIDIR_CUENTA === true}
                    comensales={datosPagoMesa.comensales}
                    metodosPersonalizados={metodosPagoPersonalizados}
                />
            )}
            {alertaExito.visible && (
                <div className="sh-alert-success">
                    <i className="fas fa-check text-success" style={{ backgroundColor: 'white' }}></i>
                    <div>
                        <h5 style={{ margin: 0, fontWeight: '600', fontSize: '1.05rem', lineHeight: '1.2' }}>
                            {alertaExito.titulo}
                        </h5>
                        <small style={{ opacity: 0.9 }}>{alertaExito.mensaje}</small>
                    </div>
                </div>
            )}
            <ToastContainer position="top-right" autoClose={2500} />
        </div>
    );
};

export default CatalogoMesas; // O PedidosMesaForm, según como lo uses/configuracion/parametros/